import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box, Button, Typography, TextField } from "@material-ui/core";
import { useIntl } from "react-intl";
import { messages } from "../../../../messages";
import { sendBuyoutEmail } from "../../../../endpoints/CoreBuyout";
import { clsx } from "clsx";
const EmailForm = ({ email, setEmail, setEmailSent, onClose, classes, applicationNumber, paymentInfo }) => {
    const [touched, setTouched] = useState(false);
    const [emailBeingSent, setEmailBeingSent] = useState(false);
    const [error, setError] = useState(null);
    const intl = useIntl();
    // Simple email regex validation
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    /**
     * Sends the buyout offer email to the provided address.
     * Shows error in UI if sending fails.
     */
    const sendEmail = async () => {
        try {
            setEmailBeingSent(true);
            setError(null);
            const body = new FormData();
            body.append("recipientEmail", email);
            body.append("applicationNumber", applicationNumber);
            body.append("attachmentData", paymentInfo?.Pdf);
            const resp = await sendBuyoutEmail(body);
            if (resp && resp.success !== true) {
                setError("Error when sending message. " + (resp.error || "Unknown error"));
                setEmailBeingSent(false);
                return;
            }
            setEmailBeingSent(false);
            setEmailSent(true);
        }
        catch (err) {
            setEmailBeingSent(false);
            setError("Error when sending message. " + (err.message || ""));
        }
    };
    return (_jsxs(Box, { className: classes.slideinContent, children: [_jsxs(Box, { className: classes.emailForm, children: [_jsx(Typography, { className: classes.emailSubtitle, children: intl.formatMessage(messages.slideinEmailAddress) }), _jsx(TextField, { value: email, onChange: e => {
                            setEmail(e.target.value);
                            if (!touched)
                                setTouched(true);
                        }, onBlur: () => setTouched(true), placeholder: "r\u00E5dgiver@epost.no", className: classes.emailInput, error: touched && !isValidEmail, helperText: touched && !isValidEmail
                            ? intl.formatMessage(messages.slideinEmailInvalid)
                            : "" }), error && (_jsx(Typography, { color: "error", variant: "body2", style: { marginTop: 8 }, children: error }))] }), _jsx(Button, { variant: "outlined", onClick: sendEmail, className: clsx(classes.button, classes.buttonEmailOverlay), disabled: !isValidEmail || emailBeingSent, children: emailBeingSent
                    ? "Sender..."
                    : intl.formatMessage(messages.slideinEmailSend) })] }));
};
export default EmailForm;
//# sourceMappingURL=EmailForm.js.map